export const sectionStyles = {
  alignSection: 'flex flex-col justify-center',
  label: 'mr-3 font-medium text-lg',
  checkbox: 'mr-2 appearance-none w-5 h-5 bg-customGray rounded-sm focus:ring focus:ring-blue-300 checked:bg-customCream checkbox-with-checkmark',
}